export const streamers = [
  {
    id: 'ESL_SC2',
    logo: 'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/streamers/ESL_SC2.png',
    banner:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/banners/esl_sc2.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
    followers: Math.floor(Math.random() * 10000) + 100,
    videos: Math.floor(Math.random() * 200) + 20,
  },
  {
    id: 'OgamingSC2',
    logo: 'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/streamers/OG_SC2.png',
    banner:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/banners/og-sc2.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
    followers: Math.floor(Math.random() * 10000) + 100,
    videos: Math.floor(Math.random() * 200) + 20,
  },
  {
    id: 'cretetion',
    logo: 'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/streamers/cretetion.png',
    banner:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/banners/cretetion.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
    followers: Math.floor(Math.random() * 10000) + 100,
    videos: Math.floor(Math.random() * 200) + 20,
  },
  {
    id: 'freecodecamp',
    logo: 'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/streamers/freecodecamp.png',
    banner:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/banners/freecodecamp.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
    followers: Math.floor(Math.random() * 10000) + 100,
    videos: Math.floor(Math.random() * 200) + 20,
  },
  {
    id: 'storbeck',
    banner:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/banners/league.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
    followers: Math.floor(Math.random() * 10000) + 100,
    videos: Math.floor(Math.random() * 200) + 20,
  },
  {
    id: 'habathcx',
    banner:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/banners/wow.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
    followers: Math.floor(Math.random() * 10000) + 100,
    videos: Math.floor(Math.random() * 200) + 20,
  },
  {
    id: 'RobotCaleb',
    logo: 'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/streamers/RobotCaleb.png',
    banner:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/banners/code.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
    followers: Math.floor(Math.random() * 10000) + 100,
    videos: Math.floor(Math.random() * 200) + 20,
  },
  {
    id: 'noobs2ninjas',
    logo: 'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/streamers/noobs2ninjas.png',
    banner:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/banners/codespiral.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
    followers: Math.floor(Math.random() * 10000) + 100,
    videos: Math.floor(Math.random() * 200) + 20,
  },
];

export const lives = [
  {
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/lives/live1.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
  },
  {
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/lives/live2.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
  },
  {
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/lives/live3.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
  },
  {
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/lives/live4.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
  },
  {
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/lives/live5.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
  },
  {
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/lives/live6.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
  },
  {
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/lives/live7.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
  },
  {
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/lives/live8.jpg',
    viewers: Math.floor(Math.random() * 500) + 10,
  },
];

export const games = [
  {
    slug: 'dota2',
    name: 'Dota 2',
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/games/dota2.jpg',
    tags: ['MOBA', 'Action'],
    viewers: Math.floor(Math.random() * 40000) + 20000,
  },
  {
    slug: 'fortnite',
    name: 'Fortnite',
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/games/fortnite.jpg',
    tags: ['Shooter', 'Action'],
    viewers: Math.floor(Math.random() * 60000) + 60000,
  },
  {
    slug: 'hearthstone',
    name: 'Hearthstone',
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/games/hearthstone.jpg',
    tags: ['Card & Board Game'],
    viewers: Math.floor(Math.random() * 60000) + 30000,
  },
  {
    slug: 'l2',
    name: 'Lineage 2',
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/games/lineage2.jpg',
    tags: ['RPG', 'Adventure Game'],
    viewers: Math.floor(Math.random() * 60000) + 10000,
  },
  {
    slug: 'valorant',
    name: 'Valorant',
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/games/valorant.jpg',
    tags: ['Shooter', 'FPS'],
    viewers: Math.floor(Math.random() * 60000) + 30000,
  },
  {
    slug: 'wow',
    name: 'World of Warcraft',
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/games/wow.jpg',
    tags: ['RPG', 'Adventure Game'],
    viewers: Math.floor(Math.random() * 60000) + 20000,
  },
  {
    slug: 'codmw',
    name: 'Call of Duty: Modern Warfare II',
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/games/codmw.jpg',
    tags: ['Shooter', 'Action'],
    viewers: Math.floor(Math.random() * 60000) + 20000,
  },
  {
    slug: 'lol',
    name: 'League of Legends',
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/games/league.jpg',
    tags: ['MOBA', 'Action'],
    viewers: Math.floor(Math.random() * 50000) + 50000,
  },
  {
    slug: 'ow2',
    name: 'Overwatch 2',
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/games/overwatch2.jpg',
    tags: ['FPS', 'Shooter'],
    viewers: Math.floor(Math.random() * 60000) + 60000,
  },
  {
    slug: 'apex',
    name: 'Apex Legends',
    thumb:
      'https://raw.githubusercontent.com/gestok/streaming-app/main/src/assets/thumbs/games/apexlegends.jpg',
    tags: ['FPS', 'Shooter'],
    viewers: Math.floor(Math.random() * 60000) + 60000,
  },
];
